// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5374":"febb12b4","9265":"54242e58"}[chunkId] + ".chunk.css";
};